export default "__VITE_ASSET__DBbUc8WI__"